/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Der Bestellung hinzufügen",
  "i18n.additionalProducts.emotionalHook": "♥️ Beliebt:",
  "i18n.additionalProducts.productDescription": "Produktbeschreibung",
  "i18n.additionalProducts.showMore": "Mehr Infos",
  "i18n.additionalProducts.title": "Passendes Zubehör",
  "i18n.button.addToCart": "In den Warenkorb",
  "i18n.button.cropImage": "Zuschneiden",
  "i18n.button.apply": "Übernehmen",
  "i18n.button.back": "Zurück",
  "i18n.button.cancel": "Abbrechen",
  "i18n.button.cancelAndFix": "Design vervollständigen",
  "i18n.button.cancelAndAddImage": "Jetzt Foto hinzufügen",
  "i18n.button.close": "Schließen",
  "i18n.button.continue": "Weiter",
  "i18n.button.ignore": "Ignorieren",
  "i18n.button.ignoreAndContinue": "Trotzdem weiter",
  "i18n.button.ignoreAndContinueOrder": "Trotzdem bestellen",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "keine Änderung",
  "i18n.button.design": "Design",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Erneut versuchen",
  "i18n.button.uploadPhotos": "Fotos hochladen",
  "i18n.button.withSmartSorted": "Mit SMART SORTED",
  "i18n.button.withoutSmartSorted": "Ohne SMART SORTED",
  "i18n.button.continueDesigning": "Weiter gestalten",
  "i18n.button.returnToHomePage": "Zur Startseite zurückkehren",
  "i18n.button.deleteImage": "Bild löschen",
  "i18n.button.withoutPhoto": "Ohne Foto weiter",
  "i18n.button.withoutThisPhoto": "Ohne dieses Foto weiter",
  "i18n.button.chooseNewImage": "Neues Bild auswählen",
  "i18n.button.chooseOtherPhoto": "Anderes Foto wählen",
  "i18n.button.retryPhoto": "Foto erneut hochladen",
  "i18n.button.reload": "Vorgang neu starten",
  "i18n.button.restartDesigner": "Gestaltung erneut beginnen",
  "i18n.button.restart": "Neu laden",
  "i18n.button.puzzleYouShop": "Zum puzzleYOU Shop",
  "i18n.button.shop": "Zurück zum Shop",
  "i18n.button.clearText": "Text entfernen",
  "i18n.button.changeProduct": "Trotzdem wechseln",
  "i18n.button.keepProduct": "{{productVariant}} behalten",
  "i18n.designStep.addCustomText": "Füge einen eigenen Text hinzu",
  "i18n.toggle.hidePuzzleOverlay": "Puzzleteile ausblenden",
  "i18n.toggle.showPuzzleOverlay": "Puzzleteile einblenden",
  "i18n.toggle.hide": "ausblenden",
  "i18n.toggle.showUsedImages": "Benutzte Fotos einblenden",
  "i18n.toggle.hideUsedImages": "Benutzte Fotos ausblenden",
  "i18n.imagePromoter.title": "Lade deine Fotos hoch",
  "i18n.imagePromoter.content": "Klicke auf „Fotos“ oder aufs Platzhalterbild, um dein Foto auszuwählen.",
  "i18n.boxPromoter.title.puzzle": "Gestalte deine Puzzle-Schachtel",
  "i18n.boxPromoter.title.memo": "Gestalte deine Memo-Schachtel",
  "i18n.boxPromoter.title.default": "Gestalte deine Schachtel",
  "i18n.boxPromoter.content.designsAndText": "Du kannst aus mehreren Designs wählen und einen Text hinzufügen.",
  "i18n.boxPromoter.content.designs": "Du kannst aus mehreren Designs wählen.",
  "i18n.boxPromoter.content.text": "Du kannst einen Text hinzufügen.",
  "i18n.control.actionBar.duplicate": "Duplizieren",
  "i18n.control.actionBar.editText": "Text bearbeiten",
  "i18n.control.actionBar.leaveTextEditing": "Textbearbeitung beenden",
  "i18n.control.actionBar.delete": "Löschen",
  "i18n.control.actionBar.rotate": "Drehen",
  "i18n.control.colorChooser.matchingColors": "Zum Design passende Farben",
  "i18n.control.colorChooser.allColors": "Alle Farben",
  "i18n.control.colorChooser.allBgColors": "Alle Hintergrundfarben",
  "i18n.control.colorChooser.lowContrastHint": "Einige Hintergrundfarben sind ausgegraut, weil sie sich zu wenig von deiner Textfarbe abheben.",
  "i18n.control.fontChooser.group.classic": "Klassisch & Seriös",
  "i18n.control.fontChooser.group.creative": "Kreativ & Speziell",
  "i18n.control.fontChooser.group.handwritten": "Handschrift & Verspielt",
  "i18n.control.fontChooser.group.modern": "Modern & Sachlich",
  "i18n.control.fontChooser.group.technical": "Technisch",
  "i18n.control.imageQuality.title.good": "Bildqualität: optimal",
  "i18n.control.imageQuality.title.medium": "Bildqualität: okay",
  "i18n.control.imageQuality.title.bad": "Bildqualität: kritisch",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "Druck kann leicht unscharf wirken.",
  "i18n.control.imageQuality.content.bad": "Druck wird unscharf & verpixelt.",
  "i18n.control.imageQuality.affectedImages": [
    "1 Bild", "{{value}} Bilder"],
  "i18n.control.imageQuality.showIndicators": "Anzeigen",
  "i18n.control.imageQuality.hideIndicators": "Ausblenden",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "Schriftarten",
  "i18n.control.textEditing.menu.effects": "Formatierung",
  "i18n.control.textEditing.menu.colors": "Farbe",
  "i18n.control.textEditing.menu.bgColors": "Hintergrund",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Für bessere Lesbarkeit bitte Textlänge / Zeilenlänge kürzen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Die gewählte Schriftart ist zu groß für diesen Text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Die maximal mögliche Schriftgröße für diesen Text wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Die minimal mögliche Schriftgröße wurde ausgewählt.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Bitte Zeilenumbruch einfügen.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Bitte Zeilenumbruch einfügen oder Textfeld vergrößern.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Bitte überprüfe Deine Eingaben, nicht alle Zeichen werden von dieser Schriftart unterstützt.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Maximale Textlänge erreicht",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Die maximale Anzahl an Zeilen ist erreicht.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Bitte Textfeld vergrößern.",
  "i18n.dialog.closeDesigner.message": "Deine Änderungen gehen verloren. Möchtest du wirklich zurück zur Startseite?",
  "i18n.dialog.closeDesigner.title": "Gestaltung abbrechen?",
  "i18n.dialog.deletePlaceholder.message": "Dieser Schritt kann nicht rückgängig gemacht werden.",
  "i18n.dialog.deletePlaceholder.title": "Platzhalter wirklich löschen?",
  "i18n.dialog.deleteGalleryImage.title": "Verwendetes Bild wirklich löschen?",
  "i18n.dialog.deleteGalleryImage.message": "Dein Bild wird gerade verwendet. Möchtest du das Bild wirklich löschen?",
  "i18n.dialog.insufficientImageQuality.message": "Die Auflösung dieses Bildes ist zu gering, um das Motiv optimal zu drucken!",
  "i18n.dialog.smartSorted.message": "Mit SMART SORTED puzzelt Ihr innovativ und mühelos euer Motiv mit 1000 Teilen auch ohne Motiv-Vorlage",
  "i18n.dialog.smartSorted.title": "Puzzle-Erfolgserlebnis garantiert",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Tippe auf „{{text}}“, damit Deine Geschenkbox noch persönlicher wird.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Kein Titel eingegeben",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "Titel hinzufügen",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Weiter ohne Titel",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Tippe auf das Platzhalterbild, um dein Foto hochzuladen.",
    "Tippe auf die Platzhalterbilder, um deine Fotos hochzuladen."
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Kein Foto ausgewählt",
    "Mehrere Bildplatzhalter wurden nicht gefüllt"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Ein Platzhalter wurde nicht geändert.",
    "Mehrere Platzhalter wurden nicht geändert."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Tippe auf die Platzhalter, um Texte und Fotos individuell zu gestalten.",
    "Tippe auf die Platzhalter, um Texte und Fotos individuell zu gestalten.",
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Noch nicht alles ausgefüllt",
    "Noch nicht alles ausgefüllt",
  ],
  "i18n.dialog.unchangedPlaceholders.title": "unveränderte Platzhalter",
  "i18n.dialog.productChooserWarning.title": "Dein Design gibt es nicht als {{productVariant}}.",
  "i18n.dialog.productChooserWarning.message": "Wenn du zu {{productVariant}} wechselst, ersetzen wir dein Design durch ein passendes, das du danach noch ändern kannst. Deine Fotos bleiben erhalten.",
  "i18n.dialog.imageQuality.title": "Bildqualität",
  "i18n.dialog.imageQuality.indicator.good": "optimal",
  "i18n.dialog.imageQuality.indicator.medium": "okay",
  "i18n.dialog.imageQuality.indicator.bad": "kritisch",
  "i18n.dialog.imageQuality.subtitle.good": "hohe Auflösung\n(scharf und detailreich)",
  "i18n.dialog.imageQuality.subtitle.medium": "mittlere Auflösung\n(verwaschen, leichte Unschärfen sichtbar)",
  "i18n.dialog.imageQuality.subtitle.bad": "niedrige Auflösung\n(unscharf und verpixelt)",
  "i18n.dialog.imageQuality.content.good": "Sehr gute Auflösung — ein scharfes und detailreiches Druckergebnis ist zu erwarten.",
  "i18n.dialog.imageQuality.content.medium": "Die aktuelle Bilddarstellung ist für den Druck geeignet, es können jedoch leichte Unschärfen sichtbar sein. Für ein besseres Ergebnis bitte ein höher aufgelöstes Bild hochladen oder den Zoom reduzieren.",
  "i18n.dialog.imageQuality.content.bad": "Das Druckergebnis wird voraussichtlich unscharf. Für ein besseres Ergebnis bitte ein höher aufgelöstes Bild hochladen oder den Zoom reduzieren.",
  "i18n.error.deprecatedBrowserError.message": "Bitte aktualisiere auf eine aktuelle Version von Chrome, Firefox, Safari oder einem ähnlichen modernen Browser.",
  "i18n.error.deprecatedBrowserError.title": "Dein Browser wird nicht mehr unterstützt",
  "i18n.error.designerExpiredError.message": "Du hast die Gestaltung für längere Zeit unterbrochen. Sie kann nicht fortgeführt werden. Bitte starte den Vorgang erneut.",
  "i18n.error.designerExpiredError.title": "Sitzung abgelaufen",
  "i18n.error.fontLoadingError.message": "Wir haben Probleme die Schriftart für dich bereitzustellen. Probiere es nochmal oder wähle eine andere Schriftart.",
  "i18n.error.fontLoadingError.title": "Schriftart konnte nicht geladen werden.",
  "i18n.error.imageLoadingError.message": "Ein Bild konnte nicht geladen werden.\nEs wurde aus der Galerie und der Gestaltungsfläche entfernt.",
  "i18n.error.imageLoadingError.title": "Ladefehler",
  "i18n.error.imageProvisionError.message": "Ein oder mehrere Bilder konnte nicht verarbeitet werden. Möglicherweise wird das Format nicht unterstützt.",
  "i18n.error.imageProvisionError.title": "Bild konnte nicht verarbeitet werden",
  "i18n.error.imageSelectionError.message": "Die Datei „{{reference1}}“ konnte nicht verarbeitet werden.",
  "i18n.error.imageSelectionError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageSizeLimitExceededError.message": "Das von Dir hochgeladene Bild hat zu große Abmessungen.\nAus technischen Gründen können wir es nicht verarbeiten.\nBitte verkleinere das Bild auf weniger als 180 Megapixel und lade es erneut hoch.",
  "i18n.error.imageSizeLimitExceededError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.imageUploadError.message": "Es scheint ein Problem mit der Internetverbindung zu geben.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.imageUploadError.title": "Fehler beim Hochladen des Bildes",
  "i18n.error.inlineSVGLoadingError.message": "Wir haben Probleme den Product Designer zu laden. Bitte lade ihn neu oder gehe zurück zum Shop.",
  "i18n.error.inlineSVGLoadingError.title": "Product Designer konnte nicht geladen werden",
  "i18n.error.invalidCharConfigError.message": "Die Schriftart ist fehlerhaft und kann nicht verwendet werden.",
  "i18n.error.invalidCharConfigError.title": "Fehlerhafte Schriftart",
  "i18n.error.malformedProductError.message": "Möglicherweise ist das Produkt nicht mehr verfügbar oder die Produktgestaltung hat zu lange gedauert.\nDas tut uns leid. Bitte beginne die Gestaltung erneut.",
  "i18n.error.malformedProductError.title": "Ein oder mehrere Produkte konnten nicht auf den Server übertragen werden",
  "i18n.error.notInStockError.message": "Wähle bitte ein anderes Produkt aus.",
  "i18n.error.notInStockError.title": "Produkt aktuell nicht verfügbar",
  "i18n.error.offlineNotice": "Deine Internetverbindung scheint unterbrochen zu sein. Du kannst mit der Gestaltung fortfahren, sobald die Verbindung wieder hergestellt wurde.",
  "i18n.error.templateLoadingError.message": "Das Template „{{ error.reference[0] }}“ konnte nicht geladen werden.\nBitte versuche es zu einem späteren Zeitpunkt noch einmal.",
  "i18n.error.templateLoadingError.title": "Ladefehler",
  "i18n.error.traudlLoadingError.message": "Bitte versuche es erneut oder verwende ein anderes Foto.",
  "i18n.error.traudlLoadingError.title": "Der AI-Filter konnte nicht angewendet werden.",
  "i18n.error.unsupportedMediaTypeError.message": "Diese Datei können wir leider nicht für dein Puzzle verwenden. Bitte lade ein Foto im Format JPG, PNG oder HEIC hoch.",
  "i18n.error.unsupportedMediaTypeError.title": "Dateiformat nicht unterstützt",
  "i18n.error.uploadProductError.message": "Ein oder mehrere Produkte konnten nicht auf den Server übertragen werden.\nMöglicherweise liegt ein Problem mit der Internetverbindung vor.",
  "i18n.error.uploadProductError.title": "Übertragungsfehler",
  "i18n.error.zoomModeError.message": "Dein Text aus dem vorherigen Design konnte nicht übernommen werden und wurde zurückgesetzt.",
  "i18n.error.zoomModeError.title": "Text nicht übernommen",
  "i18n.gallery.uploadPhotos.title": "Du hast noch keine Fotos hochgeladen",
  "i18n.gallery.uploadPhotos.message": "Klick unten auf den Button um deine Fotos auszuwählen.",
  "i18n.gallery.placedAllPhotos.title": "Alle Fotos wurden platziert",
  "i18n.gallery.placedAllPhotos.message": "Schalte oben links „Benutzte Fotos einblenden“ an, um deine hochgeladenen Fotos wieder zu sehen.",
  "i18n.price.price": "Preis",
  "i18n.price.reduction": "Du sparst",
  "i18n.price.total": "Gesamtpreis",
  "i18n.priceDisplay.times": [
    "{{value}} Stück à {{pricePerUnit}}",
    "{{value}} Stück à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Zubehör wählen",
  "i18n.progressOverlay.message.lines.one": "Danke für die schöne Gestaltung.",
  "i18n.progressOverlay.message.lines.two": "Wir bereiten alles für Dich vor...",
  "i18n.template.insertText": "Hier Text eingeben",
  "i18n.toolbox.image.title": "Bild bearbeiten",
  "i18n.toolbox.layout.template.count": [
    "1 Design",
    "{{value}} Designs"
  ],
  "i18n.toolbox.layout.template.inUse": 'In Verwendung',
  "i18n.toolbox.layout.template.suitableFor": [
    "1 Bild",
    "{{value}} Bilder"
  ],
  "i18n.toolbox.layout.title": "Designs",
  "i18n.toolbox.layout.titleBox": "Schachtel-Designs",
  "i18n.toolbox.preview.title": "3D Vorschau",
  "i18n.toolbox.productChooser.title": "Produkt ändern",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "Deine Fotos und dein Design bleiben beim Wechsel bestehen.",
  "i18n.toolbox.productChooser.contentMessage.two": "Sollte ein Design für die neue Größe nicht verfügbar sein, informieren wir dich vor der Umstellung.",
  "i18n.toolbox.textEdit.title": "Textfelder",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "Du hast noch keine Textfelder platziert.",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "Klick unten auf den Button um ein neues Textfeld zu platzieren.",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "Textfeld hinzufügen",
  "i18n.toolbox.text.boxTitle": "Schachtel-\nText",
  "i18n.toolbox.text.title": "Text eingeben",
  "i18n.toolbox.imageEdit.title": "Foto bearbeiten",
  "i18n.toolbox.imageEdit.removeImageMobile": "Entfernen",
  "i18n.toolbox.imageEdit.removeImageDesktop": "Foto entfernen",
  "i18n.toolbox.imageEdit.swapImage": "Austauschen"
};


export class LocaleDeDE {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
